export default "__VITE_ASSET__CcwFnjBQ__"